import { segmentEvents } from "@/src/constants/segmentEvents";
import { segmentClient } from "@/src/utils/segment";

export const segmentEventLoginFailed = (email: string) => {
  segmentClient.track(segmentEvents.loginFailed, {
    email,
  });
};
